import React from 'react';
import { Nav, NavItem, Badge } from 'reactstrap';
import { NavLink } from 'react-router-dom';
import NotificationMessage from './NotificationMessageComponent';
import { Package, Route, Search, MessageCircle, User } from '../../icons';
import { currentUser } from '../../redux/helpers/currentUser';

const tabs = [
    { route: '/adddelivery',         Icon: Package,       label: 'Envoyer'   },
    { route: '/addtrip',             Icon: Route,         label: 'Trajet'    },
    { route: '/searchannouncements', Icon: Search,        label: 'Chercher'  },
    { route: '/messages',            Icon: MessageCircle, label: 'Messages'  },
    { route: '/profil',              Icon: User,          label: 'Profil'    },
];

const Navigation = (props) => {
    if (window.location.pathname.split('/')[1] === 'messages' && window.location.pathname.split('/')[2] != null)
        return <div></div>;

    const user = currentUser();

    return (
        <div>
            <nav className="navbar fixed-bottom navbar-light bottom-tab-nav d-block d-sm-none" role="navigation">
                <Nav className="w-100">
                    <div className="d-flex flex-row justify-content-around w-100">
                        {tabs.map(({ route, Icon, label }, index) => (
                            <NavItem key={index} style={{ flex: 1 }}>
                                <NavLink
                                    to={route}
                                    className="nav-link bottom-nav-link"
                                    activeClassName="active"
                                    style={{ padding: '8px 2px', textAlign: 'center' }}
                                >
                                    <div className="d-flex flex-column align-items-center" style={{ position: 'relative' }}>
                                        {label === 'Messages' && (
                                            <span style={{ position: 'absolute', top: -4, right: '50%', marginRight: -18 }}>
                                                <NotificationMessage isLoading={props.isLoading} notifications={props.notifications} />
                                            </span>
                                        )}
                                        {label === 'Profil' && user && user.id && !(user.numberMobile && user.birthDate) && (
                                            <span style={{ position: 'absolute', top: -4, right: '50%', marginRight: -18 }}>
                                                <Badge color="danger" pill style={{ fontSize: '0.6rem' }}>!</Badge>
                                            </span>
                                        )}
                                        <Icon size={20} />
                                        <div className="bottom-tab-label" style={{ fontSize: '0.65rem', marginTop: 3, whiteSpace: 'nowrap' }}>
                                            {label}
                                        </div>
                                    </div>
                                </NavLink>
                            </NavItem>
                        ))}
                    </div>
                </Nav>
            </nav>
        </div>
    );
};

export default Navigation;
